<template>
  <div :class="wrapperClass" class="flex items-center gap-2 text-xs px-2 py-1 rounded-md">
    <span :class="dotClass" class="w-2 h-2 rounded-full"></span>
    <span>{{ online ? 'آنلاین' : 'آفلاین' }}</span>
  </div>
  
</template>

<script>
import { useNetworkStatus } from '@/services/network'

export default {
  name: 'NetworkIndicator',
  setup() {
    const { online } = useNetworkStatus()
    const wrapperClass = online.value ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
    const dotClass = online.value ? 'bg-green-500' : 'bg-red-500'
    return { online, wrapperClass, dotClass }
  }
}
</script>

<style scoped>
</style>


